import { isValid, parseISO } from "date-fns";

const parseStringDate = (dateString: string): Date => {
  const ISODate = new Date(dateString).toISOString();
  return parseISO(ISODate);
};

export const convertStingToDate = (value: string | null) => {
  if (!value) return null;
  const date = parseStringDate(value);

  if (!isValid(date)) {
    return null;
  }

  return date;
};
